import { AgeWarning } from "components/AgeWarning";
import { PageProps } from "gatsby";
import { WarningContextProvider } from "hooks/useAgeWarningState";
import { DMMPopupContextProvider } from "hooks/useDMMPopupState";
import { useMetadata } from "hooks/useMetadata";
import { SoundWarningContextProvider } from "hooks/useSoundWarning";
import React from "react";

import { Player } from "@lottiefiles/react-lottie-player";

export default function MyModal({
    children,
    pageContext,
}: PageProps<null, { layout: string; language: string }>) {
    const metadata = useMetadata();

    if (pageContext.layout === "no-layout") return <>{children}</>;

    return (
        <WarningContextProvider>
            <SoundWarningContextProvider>
                <DMMPopupContextProvider>
                    {children}
                    <Player
                        autoplay
                        loop
                        speed={0.3}
                        src="/confetti.json"
                        className="opacity-60 fixed inset-0 portrait:w-[100vh] landscape:h-[100vw] [&_svg]:transform [&_svg]:!rotate-90 pointer-events-none"
                    />
                    <AgeWarning />
                </DMMPopupContextProvider>
            </SoundWarningContextProvider>
        </WarningContextProvider>
    );
}
